import { EmptyState } from '@coast/schemas';
import { MBEmptyListPlaceholder } from '@shared/components/list';

interface Props extends EmptyState {
  testID?: string;
}

export function MBCardEmptyState({ title, message, imageUri, testID }: Props) {
  return (
    <MBEmptyListPlaceholder
      title={title}
      description={message}
      image={!!imageUri ? { uri: imageUri } : undefined}
      testID={testID}
    />
  );
}
